const message = {
  path: 'message/:messageId',
  props: true,
  component: resolve => require(['../../../../components/pages/user/message'], resolve)
}

export default message



// WEBPACK FOOTER //
// ./src/router/pages/user/message/index.js